import React, { useRef, useState } from "react";
import {
  ComponentSingleStyleConfig,
  useDisclosure,
  useOutsideClick,
  useStyleConfig,
} from "@chakra-ui/react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import { CMButtonSearchCondition } from "../CMButtonSearchCondition/CMButtonSearchCondition";
import { CMButtonPopupSearchConditionText } from "../../button-popup";

export type CMButtonSearchConditionTextProps = {
  label: string;
  placeholder: string;

  /**
   * 最大文字数
   */
  maxLength?: number;

  value?: string | null;

  hideClearButton?: boolean;

  labelSubmit?: string;
  labelClear?: string;

  onChange?: (value: string | null) => void;
} & ComponentStyleProps;

export const CMButtonSearchConditionText = ({
  label,
  placeholder,

  maxLength,

  value = null,

  hideClearButton = false,

  labelSubmit,
  labelClear,

  onChange,

  sx,
  ...rest
}: CMButtonSearchConditionTextProps) => {
  const styles = useStyleConfig("CMButtonSearchConditionTextStyles");

  const {
    isOpen: isOpenPopup,
    onClose: onClosePopup,
    onToggle: onTogglePopup,
  } = useDisclosure();

  const [internalValue, setInternalValue] = useState<string>(value ?? "");

  const resetAllInternalState = (newValue: string | null = value) => {
    setInternalValue(newValue ?? "");
  };

  const handleChangeInternalValue = (v: string) => {
    setInternalValue(v);
  };

  /**
   * Submitボタン押下時、呼び出し元に選択値を返却する。
   */
  function handleSubmit() {
    // 空文字列はクリア扱いとする。
    const submittedValue = internalValue === "" ? null : internalValue;

    onClosePopup();
    resetAllInternalState(submittedValue);
    onChange?.(submittedValue);
  }

  /**
   * Clearボタン押下時、呼び出し元にnullを返却する。
   */
  function handleClear() {
    onClosePopup();
    resetAllInternalState(null);
    onChange?.(null);
  }

  const ref = useRef(null);
  useOutsideClick({
    ref: ref,
    handler: () => {
      onClosePopup();
      resetAllInternalState();
    },
  });

  return (
    <CMButtonSearchCondition
      label={label}
      displayValue={value}
      isOpenPopup={isOpenPopup}
      onClick={onTogglePopup}
      sx={{ ...styles, ...sx }}
      {...rest}
      ref={ref}
    >
      <CMButtonPopupSearchConditionText
        placeholder={placeholder}
        maxLength={maxLength}
        labelSubmit={labelSubmit}
        labelClear={labelClear}
        hideClearButton={hideClearButton}
        internalValue={internalValue}
        onChangeInternalValue={handleChangeInternalValue}
        onSubmit={handleSubmit}
        onClear={handleClear}
      />
    </CMButtonSearchCondition>
  );
};
export const CMButtonSearchConditionTextStyles: ComponentSingleStyleConfig = {
  baseStyle: {},
};
